import router from "@/router";

let commonAudio = null;

const Helpers = {
    isNull: function(str) {
        return typeof (str) == "undefined" || str == null || str === "";
    },
    is_json(sentence) {
        let ret = {
            "result": false,
            "data": null
        }
        // 判断sentence是否为json
        try {
            ret["data"] = JSON.parse(sentence);
        } catch (e) {
            console.log(e);
            return ret;
        }
        ret["result"] = true;
        return ret;
    },
    guid: function(){
        let now = new Date().getTime()
        let str = 'xxxxxxxx-xxxx-'+now+'-yxxx'
        return str.replace(/[xy]/g, function(c){
            let r = Math.random() * 16 | 0
            let v = c === 'x' ? r: (r&0x3|0x8)
            return v.toString(16)
        })
    },
    inArray: function(search,array){
        for(let i in array){
            if(array[i]===search){
                return true;
            }
        }
        return false;
    },
    formatFileSize: function(bytes) {
        const k = 1024;
        const units = ["Bytes", "KB", "MB", "GB", "TB"];
        if (bytes < 1) return "0 Bytes";
        // 计算单位索引，避免超出数组范围
        const i = Math.min(
            Math.floor(Math.log(bytes) / Math.log(k)),
            units.length - 1
        );
        const size = bytes / Math.pow(k, i);
        // 若为整数则省略小数部分
        return `${size % 1 === 0 ? size : size.toFixed(2)} ${units[i]}`;
    },
    getEnumValue: function(key, array, defaultVal=null){
        if (array[key] === undefined) {
            return defaultVal
        } else {
            return array[key]
        }
    },
    getCurrentAdmin(){
       let ret = localStorage.getItem("admin");
       if (ret === null || ret === "") {
           return null;
       }
       return JSON.parse(ret);
    },
    setCurrentAdmin(admin){
        localStorage.setItem("admin", JSON.stringify(admin));
    },
    clearCurrentAdmin(){
        localStorage.removeItem("admin");
    },
    jumpTo(url){
        if (url.startsWith('http')) {
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank"; // 关键属性
            link.style.display = "none"; // 隐藏标签
            document.body.appendChild(link);
            link.click(); // 触发点击
            document.body.removeChild(link); // 清理DOM
        } else {
            router.push(url);
        }
    },
    valToLabel(val, consts, defaultLabel="", valKey="value", labelKey="label") {
          val = val.toString();
          for (let i of consts) {
              if (val === i[valKey]) {
                  return i[labelKey];
              }
          }
          return defaultLabel
    },
    urlToCdn(url){
        const CDN_DOMAIN_LIST = [
            {
                "orig": "sg-1319632306.cos.ap-singapore.myqcloud.com",
                "cdn": "galaxy-sg.soulexe.com"
            },
            {
                "orig": "pub-1319632306.cos.ap-shanghai.myqcloud.com",
                "cdn": "galaxy-sh.soulexe.com"
            }
        ]
        for (let item of CDN_DOMAIN_LIST){
            url = url.replace(item['orig'], item["cdn"])
        }
        return url
    },
    stopAudio(){
        if (commonAudio !== null) {
            commonAudio.pause();
        }
    },
    playAudio(url, onEnd=null, onError=null) {
        if (commonAudio === null) {
            commonAudio = new Audio();
        }
        // 设置音频源
        commonAudio.src = url;
        commonAudio.addEventListener('ended', () => {
            if (typeof onEnd === 'function') {
                onEnd();
            }
        }, { once: true });
        // 播放
        commonAudio.play().catch(e => {
            console.error("播放失败:", e)
            if (typeof onError === 'function') {
                onError(e);
            }
        });
    },
    isDev: function(){
        let domain = document.domain
        return domain.startsWith('dev-')
    },
    isHTTPS: function(){
        console.log(window.location.protocol);
        return window.location.protocol === 'https:';
    },
    isTest: function(){
        let domain = document.domain
        return domain.startsWith('test-')
    },
    scrollBottom(elementId){
        let element = document.getElementById(elementId);
        let i = 1
        function main() {
            if (element.scrollTop + element.clientHeight === element.scrollHeight) {
                clearInterval(interval)
                console.log('已经到底部了')
            } else {
                element.scrollTop += 300;
                console.log(i);
                i    += 1;
            }
        }
        // 定义ID
        let interval = setInterval(main, 50);
    },
    scrollTop(elementId){
        let element = document.getElementById(elementId);
        let i = 1
        function main() {
            if (element.scrollTop <= 300) {
                element.scrollTop = 0;
                clearInterval(interval)
                console.log('已经到底部了')
            } else {
                element.scrollTop -= 300;
                console.log(i);
                i    += 1;
            }
        }
        // 定义ID
        let interval = setInterval(main, 50);
    }

}

export default Helpers

